import { isTimeZone } from '@shared/home';

/** This browser's time zone. Day, week and quarter boundaries the server works out follow it. */
const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const BROWSER_TZ = isTimeZone(detected) ? detected : 'UTC';
